import { makeStyles } from "@material-ui/core";


export default makeStyles((theme) => ({
    actionButtons: {
        flexWrap: "nowrap",
        width: "auto",
        position: "absolute",
        zIndex: 4,
        bottom: 0,
        right: 0,
        padding: 10,
    },
    closeButton: {
        position: "absolute",
        top: 12,
        left: 10,
        padding: 8,
        height: 40,
        width: 40,
        zIndex: 4,
        color: theme.palette.common.white,
        backgroundColor: "rgba(51, 51, 51, 0.65)",
        "&:hover": {
            color: theme.palette.secondary.light,
            backgroundColor: "rgba(51, 51, 51, 0.45)",
        },
    },
    camerasContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-evenly",
        flexWrap: "wrap",
        height: "100%",
        width: "100%",
    },
    fadeControls: {
        position: "absolute",
        height: "100%",
        width: "100%",
        opacity: 0.2,
        transition: "opacity 0.15s linear 0.5s",
        "&:hover": {
            opacity: 1,
            transitionDelay: "0s",
        },
    },
    fullScreenButton: {
        position: "absolute",
        top: 0,
        right: 0,
        padding: 10,
        zIndex: 4,
        backgroundColor: "rgba(51, 51, 51, 0.65)",
        "&:hover": {
            color: theme.palette.secondary.light,
            backgroundColor: "rgba(51, 51, 51, 0.45)",
        },
    },
    hoverOverlayContent: {
        position: "absolute",
        width: "100%",
        bottom: 0,
        left: 0,
        background: "linear-gradient(0deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.5) 50%, rgba(0,0,0,0) 100%)",
        zIndex: 4,
    },
    item: {
        backgroundColor: theme.palette.primary.dark,
        position: "relative",
        "& video": {
            objectFit: "contain",
        },
        "& image": {
            objectFit: "contain",
        },
    },
    overlayText: {
        display: "inline-block",
        "& a": {
            color: theme.palette.common.white,
        },
        padding: 10,
    },
    header: {
        backgroundColor: theme.palette.common.white,
        height: "auto",
    },
    title: {
        flexGrow: 1,
    },
    body: {
        backgroundColor: theme.palette.common.black,
    },
    footer: {
        height: "auto",
        bottom: 0,
        position: "absolute",
    },
}));
